<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import modal from './modal.vue';
import {useStore} from "vuex";
import { useI18n } from "vue-i18n/index";
import ApiService from '@/core/services/ApiService';
import { Mutations } from "@/store/enums/StoreEnums";
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const { t } = useI18n();
const user = computed(() => store.getters.currentUser);
const certification = ref({name: 'Hakai Certification', grade:10, });
const showModal = computed(() => store.getters.getShowCertificationAchievements);
const load = async () => {
  const certificationAchievement = user.value.achievements.find(a => a.type === 'certification_completed');
  if (modalRef.value){
    try{
        const {data} = await ApiService.get(`/achievements/certifications/${certificationAchievement.achivable_id}/user/${user.value.id}`);
        certification.value = data.certification;
        modalRef.value.open();
    }catch(error){
      console.error("Error fetching certification data:", error);
    }
  }
};
const modalRef = ref(null);
onMounted(() => {
    if (showModal.value) {
        load()
    }
});
watch(showModal, async (newVal) => {
    if (newVal) {
        load()
    }
});
const markAsRead = async ()=>{
    const certification = user.value.achievements.find(a => a.type === 'certification_completed');
    if(certification && !certification.read){
        try{
            await ApiService.put(`/achievements/${certification.id}/mark-as-read`);
            store.commit(Mutations.SET_SHOW_CERTIFICATION_ACHIEVEMENTS, false);
        }catch(error){
            console.error("Error marking achievement as read:", error);
        }
    }else{
        store.commit(Mutations.SET_SHOW_CERTIFICATION_ACHIEVEMENTS, false);
    }
}
const shareOnLinkedin = (userId) => {
  const certificationAchievement = user.value.achievements.find(a => a.type === 'certification_completed');
  const url = `${process.env.VUE_APP_SHARE_URL}achievement/certification/${certificationAchievement.achivable_id}/user/${userId}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
  window.open(linkedinUrl, "_blank");
};
</script>

<template>
<modal ref="modalRef" target="certification_modal">
      <template #header>
        <div>
          <div class="w-100 d-flex justify-content-end" style="position: absolute; top: 10px; right: 10px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="markAsRead">X</button>
          </div>
          <div class="mb-12 d-flex justify-content-center">
            <img src="/media/logos/hc.svg" class="avatar-img img-fluid floating" style="width: 15%;" alt="image" />
          </div>
          <h3 class="text-center w-100" style="color:#9203DD;font-size: 24px;font-weight: bold">{{ t(`${currentLanguage}.achivement.certification.title`) }}
            <small class="bi bi-check-circle-fill text-success fs-2"></small>
          </h3>
        </div>
      </template>
      <template #body>
        <p style="font-weight: bold; text-align: center">
          {{ t(`${currentLanguage}.achivement.certification.message_1`, { user: user.nick}) }}
        </p>
        <p class="text-center">
          {{ t(`${currentLanguage}.achivement.certification.message_2`, { certification: certification.name }) }}
        </p>

        <div class="d-flex justify-content-between">
          <div  style="width: 50%">
            <img src="/media/hc/lux_1.png" alt="image" style="width: 110% "/>
          </div>
          <div class="d-flex flex-column align-items-center justify-content-center" style="width: 50%">
            <p style="font-weight: bold;font-size: 16px">
               {{ t(`${currentLanguage}.common.grade`) }} <span style="color:#9203DD">  {{certification.grade}} </span>
            </p>
            <button @click="shareOnLinkedin(user.id)" type="button" class="btn btn-primary mt-12" style="font-size: 13px">
              <span class="bi bi-linkedin" />
              {{ t(`${currentLanguage}.common.share_on_linkedin`) }}
            </button>
          </div>
        </div>
      </template>
</modal>
</template>